import script from "./SchedulePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SchedulePage.vue?vue&type=script&setup=true&lang=js"

import "./SchedulePage.vue?vue&type=style&index=0&id=8617fd46&lang=css"

const __exports__ = script;

export default __exports__